import React, {
    createContext,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";

const LanguageContext = createContext(null);

const STORAGE_KEY = "worldofradio_language";

export const languages = [
    { code: "de", label: "DE", name: "Deutsch" },
    { code: "en", label: "EN", name: "English" },
    { code: "no", label: "NO", name: "Norsk" },
    { code: "ko", label: "KO", name: "한국어" },
    { code: "fi", label: "FI", name: "Suomi" },
];

export const translations = {
    de: {
        // Navbar
        navDiscover: "Entdecken",
        navSearch: "Suche",
        navFavorites: "Favoriten",
        navLanguage: "Sprache",
        navProfile: "Profil",
        navMyProfile: "Mein Profil",
        navSettings: "Einstellungen",
        navAdmin: "Admin Bereich",
        navLogout: "Ausloggen",
        navLogin: "Einloggen",
        navSignup: "Registrieren",

        // Language overlay
        chooseLanguage: "Sprache wählen",
        displayLanguageFor: "Anzeigesprache für WORLDofRADIO",
        tapToSelect: "Zum Auswählen tippen",

        // Auth
        login: "Einloggen",
        register: "Registrieren",
        forgotPassword: "Passwort vergessen?",
        resetPassword: "Passwort zurücksetzen",
        welcomeBack: "Willkommen zurück",
        loginSubtitle: "Melde dich an und setze deine Reise fort",
        emailOrUsername: "E-Mail oder Benutzername",
        emailAddress: "E-Mail-Adresse",
        password: "Passwort",
        newPassword: "Neues Passwort",
        confirmPassword: "Passwort bestätigen",
        signUpQuestion: "Noch kein Konto?",
        signUp: "Registrieren",
        backToHome: "Zurück zur Startseite",
        backToLogin: "Zurück zum Login",
        createAccount: "Konto erstellen",
        createAccountSubtitle: "Werde Teil der globalen Radio-Community",
        fullName: "Vollständiger Name",
        username: "Benutzername",
        alreadyHaveAccount: "Du hast bereits ein Konto?",
        sendResetLink: "Reset-Link senden",
        setNewPassword: "Neues Passwort setzen",

        // Discover
        discoverTitle: "Radio entdecken",
        discoverSubtitle: "Entdecke Sender aus der ganzen Welt",
        searchPlaceholder: "Sender, Länder, Städte suchen...",
        allGenres: "Alle Genres",
        trendingNow: "Aktuell beliebt",
        newStations: "Neue Sender",
        allStations: "Alle Sender",
        noStationsFound: "Keine Sender gefunden.",
        plays: "Wiedergaben",

        // Notifications / Friends
        notificationsTitle: "Benachrichtigungen",
        notificationsSubtitle: "Freundschaftsanfragen und Updates von WORLDofRADIO.",
        friendRequests: "Freundschaftsanfragen",
        noFriendRequests: "Keine offenen Freundschaftsanfragen.",
        updates: "Updates",
        noNotifications: "Noch keine Benachrichtigungen.",
        unreadNotification: "ungelesene Benachrichtigung",
        unreadNotifications: "ungelesene Benachrichtigungen",
        markAllAsRead: "Alle als gelesen markieren",
        loadingNotifications: "Benachrichtigungen werden geladen...",
        accept: "Annehmen",
        reject: "Ablehnen",
        unknownUser: "Unbekannter User",
        wantsToBeFriend: "möchte mit dir befreundet sein",
        refresh: "Aktualisieren",

        // User search / friendship
        users: "User",
        userSearch: "User suchen",
        userSearchPlaceholder: "Benutzername, Name, Land oder Musikrichtung suchen...",
        noUsersFound: "Keine User gefunden.",
        addFriend: "Freund hinzufügen",
        requestSent: "Anfrage gesendet",
        friends: "Freunde",
        incomingRequest: "Anfrage erhalten",
        viewProfile: "Profil ansehen",

        // Legal common
        legalBack: "Zurück",
        legalContact: "Kontakt",
        legalWebsite: "Website",
        legalAddress: "Anschrift",
        legalEmail: "E-Mail",
        legalOperator: "Betreiber",
        legalOpen: "Öffnen",
        legalSectionTitle: "Rechtliches",

        // Footer / Settings legal labels
        imprintLink: "Impressum",
        privacyLink: "Datenschutz",
        imprintCardText: "Betreiberangaben und Anbieterkennzeichnung.",
        privacyCardText: "Informationen zur Verarbeitung personenbezogener Daten.",

        // Imprint page
        imprintBadge: "Anbieterkennzeichnung",
        imprintTitle: "Impressum",
        imprintSubtitle: "Angaben gemäß den gesetzlichen Informationspflichten für WORLD OF RADIO.",
        imprintOperatorTitle: "Betreiber",
        imprintOperatorLabel: "Betreiber dieser Website",
        imprintProjectTitle: "Projekt und Markenhinweis",
        imprintProjectLabel: "Projekt",
        imprintProjectName: "WORLD OF RADIO by VMS Recording",
        imprintBrandLabel: "Markenhinweis",
        imprintBrandText: "VMS „Vinyl macht sexy“ ist eine beim Deutschen Patent- und Markenamt eingetragene Wort-/Bildmarke von Martin Wolf.",
        imprintRegisterNumber: "Registernummer",
        imprintExternalTitle: "Hinweis zu externen Inhalten",
        imprintExternalText: "WORLD OF RADIO stellt Radiosender, Senderinformationen, Streamdaten und gegebenenfalls Senderlogos dar. Inhalte, Streams, Logos und Metadaten können von externen Quellen oder den jeweiligen Radiosendern stammen.",

        // Privacy page
        privacyBadge: "Datenschutz",
        privacyTitle: "Datenschutzerklärung",
        privacyIntro: "Diese Datenschutzerklärung informiert darüber, welche personenbezogenen Daten bei der Nutzung von WORLD OF RADIO verarbeitet werden und zu welchen Zwecken dies geschieht.",
        privacyControllerTitle: "Verantwortlicher",
        privacyProcessedDataTitle: "Welche Daten verarbeitet werden",
        privacyProcessedDataIntro: "Bei der Nutzung von WORLD OF RADIO können insbesondere folgende Daten verarbeitet werden:",
        privacyDataEmail: "E-Mail-Adresse",
        privacyDataUsername: "Benutzername",
        privacyDataPasswordHash: "Passwort-Hash",
        privacyDataProfile: "Profilangaben wie Land, Musikrichtungen und Bio",
        privacyDataAvatar: "Profilbild oder Avatar, sofern genutzt",
        privacyDataLanguage: "Spracheinstellung",
        privacyDataFavorites: "Favoriten",
        privacyDataComments: "Kommentare und Kommentar-Likes",
        privacyDataFriends: "Freundschaftsanfragen und Freundschaften",
        privacyDataNotifications: "Benachrichtigungen innerhalb der Plattform",
        privacyDataSession: "technische Login- und Session-Daten",
        privacyDataAccess: "technische Zugriffsdaten wie IP-Adresse, Zeitstempel, Browser- und Geräteinformationen",
        privacyPurposeTitle: "Zwecke der Verarbeitung",
        privacyPurposeText: "Die Verarbeitung erfolgt, um WORLD OF RADIO bereitzustellen, Benutzerkonten zu verwalten, Login und Registrierung zu ermöglichen, Radiosender darzustellen, Favoriten, Kommentare, Freundschaften und Benachrichtigungen technisch umzusetzen sowie die Sicherheit und Stabilität der Plattform zu gewährleisten.",
        privacyHostingTitle: "Hosting und technische Infrastruktur",
        privacyHostingText1: "WORLD OF RADIO wird über Vercel bereitgestellt. Beim Aufruf der Website können technische Zugriffsdaten verarbeitet werden, die für Auslieferung, Sicherheit, Stabilität und Betrieb der Website erforderlich sind.",
        privacyHostingText2: "Das Frontend basiert auf React. Das Backend ist als Python-/FastAPI-Anwendung umgesetzt. Die Datenhaltung erfolgt über MongoDB Atlas.",
        privacyAnalyticsTitle: "Vercel Analytics",
        privacyAnalyticsText: "WORLD OF RADIO nutzt Vercel Analytics, um die Nutzung der Website technisch auszuwerten. Dabei können Informationen wie Seitenaufrufe, Herkunftsländer und Nutzungsstatistiken verarbeitet werden. Diese Auswertung dient dazu, die Plattform zu verbessern, technische Probleme zu erkennen und die Nutzung besser zu verstehen.",
        privacyMailTitle: "E-Mail-Versand",
        privacyMailText: "Für Registrierung, E-Mail-Verifizierung und Passwort-zurücksetzen-Funktionen wird serverseitiger SMTP-Mailversand genutzt. Die Zugangsdaten für den E-Mail-Versand werden nicht im Frontend gespeichert, sondern serverseitig über Umgebungsvariablen verwaltet.",
        privacyFontsTitle: "Google Fonts",
        privacyFontsText: "WORLD OF RADIO bindet Schriftarten über Google Fonts ein. Beim Laden dieser Schriftarten kann eine Verbindung zu Servern von Google hergestellt werden. Dabei können technische Daten wie IP-Adresse, Browserinformationen und angefragte Ressourcen übertragen werden.",
        privacyRadioTitle: "Radio Browser API und externe Senderdaten",
        privacyRadioText1: "WORLD OF RADIO nutzt externe Radiosenderdaten, insbesondere über die Radio Browser API oder vergleichbare Quellen. Dadurch können Sendernamen, Länder, Genres, Stream-URLs, Sender-Metadaten und gegebenenfalls Senderlogos angezeigt werden.",
        privacyRadioText2: "Beim Abspielen oder Öffnen von Radiosendern können außerdem Verbindungen zu externen Stream-Servern der jeweiligen Radiosender hergestellt werden. Für diese externen Inhalte und Streams sind die jeweiligen Anbieter verantwortlich.",
        privacyStorageTitle: "Cookies, Tokens und lokale Speicherung",
        privacyStorageText: "WORLD OF RADIO kann technische Cookies, Tokens oder lokale Speichermechanismen verwenden, um Login, Session-Verwaltung, Spracheinstellungen und grundlegende Plattformfunktionen zu ermöglichen. Diese technischen Speicherungen dienen der Funktionalität und Sicherheit der Plattform.",
        privacyRetentionTitle: "Speicherdauer",
        privacyRetentionText: "Personenbezogene Daten werden grundsätzlich nur so lange gespeichert, wie dies für die Bereitstellung der Plattform, gesetzliche Pflichten, Sicherheitszwecke oder berechtigte Interessen erforderlich ist. Nutzerkonten und damit verbundene Daten können auf Anfrage gelöscht werden, soweit keine gesetzlichen oder technischen Gründe entgegenstehen.",
        privacyRightsTitle: "Rechte der Nutzer",
        privacyRightsText1: "Nutzer haben im Rahmen der gesetzlichen Vorgaben insbesondere Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit sowie Widerspruch gegen bestimmte Verarbeitungen.",
        privacyRightsText2: "Anfragen zum Datenschutz können an folgende Adresse gerichtet werden:",
        privacyUpdated: "Stand dieser Datenschutzerklärung: Juni 2026. Bei zukünftigen Erweiterungen der Plattform können Anpassungen dieser Datenschutzerklärung erforderlich werden.",
    },

    en: {
        // Navbar
        navDiscover: "Discover",
        navSearch: "Search",
        navFavorites: "Favorites",
        navLanguage: "Language",
        navProfile: "Profile",
        navMyProfile: "My Profile",
        navSettings: "Settings",
        navAdmin: "Admin Dashboard",
        navLogout: "Log out",
        navLogin: "Log in",
        navSignup: "Sign up",

        // Language overlay
        chooseLanguage: "Choose language",
        displayLanguageFor: "Display language for WORLDofRADIO",
        tapToSelect: "Tap to select",

        // Auth
        login: "Log in",
        register: "Register",
        forgotPassword: "Forgot password?",
        resetPassword: "Reset password",
        welcomeBack: "Welcome back",
        loginSubtitle: "Log in to continue your journey",
        emailOrUsername: "Email or Username",
        emailAddress: "Email address",
        password: "Password",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        signUpQuestion: "Don’t have an account?",
        signUp: "Sign up",
        backToHome: "Back to home",
        backToLogin: "Back to login",
        createAccount: "Create an account",
        createAccountSubtitle: "Join the global radio community",
        fullName: "Full Name",
        username: "Username",
        alreadyHaveAccount: "Already have an account?",
        sendResetLink: "Send reset link",
        setNewPassword: "Set new password",

        // Discover
        discoverTitle: "Discover Radio",
        discoverSubtitle: "Explore stations from around the world",
        searchPlaceholder: "Search stations, countries, cities...",
        allGenres: "All Genres",
        trendingNow: "Trending Now",
        newStations: "New Stations",
        allStations: "All Stations",
        noStationsFound: "No stations found matching your search.",
        plays: "plays",

        // Notifications / Friends
        notificationsTitle: "Notifications",
        notificationsSubtitle: "Friend requests and updates from WORLDofRADIO.",
        friendRequests: "Friend requests",
        noFriendRequests: "No open friend requests.",
        updates: "Updates",
        noNotifications: "No notifications yet.",
        unreadNotification: "unread notification",
        unreadNotifications: "unread notifications",
        markAllAsRead: "Mark all as read",
        loadingNotifications: "Loading notifications...",
        accept: "Accept",
        reject: "Reject",
        unknownUser: "Unknown user",
        wantsToBeFriend: "wants to be your friend",
        refresh: "Refresh",

        // User search / friendship
        users: "Users",
        userSearch: "Search users",
        userSearchPlaceholder: "Search username, name, country or music genre...",
        noUsersFound: "No users found.",
        addFriend: "Add friend",
        requestSent: "Request sent",
        friends: "Friends",
        incomingRequest: "Request received",
        viewProfile: "View profile",

        // Legal common
        legalBack: "Back",
        legalContact: "Contact",
        legalWebsite: "Website",
        legalAddress: "Address",
        legalEmail: "Email",
        legalOperator: "Operator",
        legalOpen: "Open",
        legalSectionTitle: "Legal",

        // Footer / Settings legal labels
        imprintLink: "Imprint",
        privacyLink: "Privacy Policy",
        imprintCardText: "Operator information and legal notice.",
        privacyCardText: "Information about the processing of personal data.",

        // Imprint page
        imprintBadge: "Legal notice",
        imprintTitle: "Imprint",
        imprintSubtitle: "Information according to the legal information requirements for WORLD OF RADIO.",
        imprintOperatorTitle: "Operator",
        imprintOperatorLabel: "Operator of this website",
        imprintProjectTitle: "Project and trademark notice",
        imprintProjectLabel: "Project",
        imprintProjectName: "WORLD OF RADIO by VMS Recording",
        imprintBrandLabel: "Trademark notice",
        imprintBrandText: "VMS “Vinyl macht sexy” is a word/figurative trademark registered with the German Patent and Trade Mark Office by Martin Wolf.",
        imprintRegisterNumber: "Registration number",
        imprintExternalTitle: "Notice regarding external content",
        imprintExternalText: "WORLD OF RADIO displays radio stations, station information, stream data and, where available, station logos. Content, streams, logos and metadata may originate from external sources or the respective radio stations.",

        // Privacy page
        privacyBadge: "Privacy",
        privacyTitle: "Privacy Policy",
        privacyIntro: "This privacy policy explains which personal data is processed when using WORLD OF RADIO and for which purposes.",
        privacyControllerTitle: "Controller",
        privacyProcessedDataTitle: "Which data is processed",
        privacyProcessedDataIntro: "When using WORLD OF RADIO, the following data in particular may be processed:",
        privacyDataEmail: "Email address",
        privacyDataUsername: "Username",
        privacyDataPasswordHash: "Password hash",
        privacyDataProfile: "Profile information such as country, music genres and bio",
        privacyDataAvatar: "Profile picture or avatar, if used",
        privacyDataLanguage: "Language setting",
        privacyDataFavorites: "Favorites",
        privacyDataComments: "Comments and comment likes",
        privacyDataFriends: "Friend requests and friendships",
        privacyDataNotifications: "Notifications within the platform",
        privacyDataSession: "Technical login and session data",
        privacyDataAccess: "Technical access data such as IP address, timestamp, browser and device information",
        privacyPurposeTitle: "Purposes of processing",
        privacyPurposeText: "The processing is carried out to provide WORLD OF RADIO, manage user accounts, enable login and registration, display radio stations, technically implement favorites, comments, friendships and notifications, and ensure the security and stability of the platform.",
        privacyHostingTitle: "Hosting and technical infrastructure",
        privacyHostingText1: "WORLD OF RADIO is hosted via Vercel. When the website is accessed, technical access data may be processed that is necessary for delivery, security, stability and operation of the website.",
        privacyHostingText2: "The frontend is based on React. The backend is implemented as a Python/FastAPI application. Data storage is handled through MongoDB Atlas.",
        privacyAnalyticsTitle: "Vercel Analytics",
        privacyAnalyticsText: "WORLD OF RADIO uses Vercel Analytics to technically evaluate website usage. Information such as page views, countries of origin and usage statistics may be processed. This analysis helps improve the platform, detect technical problems and better understand usage.",
        privacyMailTitle: "Email delivery",
        privacyMailText: "Server-side SMTP email delivery is used for registration, email verification and password reset functions. Email access credentials are not stored in the frontend but are managed server-side via environment variables.",
        privacyFontsTitle: "Google Fonts",
        privacyFontsText: "WORLD OF RADIO integrates fonts via Google Fonts. When these fonts are loaded, a connection to Google servers may be established. Technical data such as IP address, browser information and requested resources may be transmitted.",
        privacyRadioTitle: "Radio Browser API and external station data",
        privacyRadioText1: "WORLD OF RADIO uses external radio station data, in particular via the Radio Browser API or comparable sources. This may display station names, countries, genres, stream URLs, station metadata and, where available, station logos.",
        privacyRadioText2: "When playing or opening radio stations, connections may also be established to external stream servers of the respective radio stations. The respective providers are responsible for these external contents and streams.",
        privacyStorageTitle: "Cookies, tokens and local storage",
        privacyStorageText: "WORLD OF RADIO may use technical cookies, tokens or local storage mechanisms to enable login, session management, language settings and basic platform functions. These technical storage mechanisms serve functionality and security of the platform.",
        privacyRetentionTitle: "Storage duration",
        privacyRetentionText: "Personal data is generally stored only as long as necessary for providing the platform, legal obligations, security purposes or legitimate interests. User accounts and related data may be deleted upon request, unless legal or technical reasons prevent deletion.",
        privacyRightsTitle: "User rights",
        privacyRightsText1: "Users have rights under the applicable legal requirements, including rights of access, rectification, deletion, restriction of processing, data portability and objection to certain processing activities.",
        privacyRightsText2: "Privacy-related requests can be sent to:",
        privacyUpdated: "Last updated: June 2026. Future extensions of the platform may require updates to this privacy policy.",
    },

    no: {
        // Navbar
        navDiscover: "Oppdag",
        navSearch: "Søk",
        navFavorites: "Favoritter",
        navLanguage: "Språk",
        navProfile: "Profil",
        navMyProfile: "Min profil",
        navSettings: "Innstillinger",
        navAdmin: "Adminpanel",
        navLogout: "Logg ut",
        navLogin: "Logg inn",
        navSignup: "Registrer deg",

        // Language overlay
        chooseLanguage: "Velg språk",
        displayLanguageFor: "Visningsspråk for WORLDofRADIO",
        tapToSelect: "Trykk for å velge",

        // Auth
        login: "Logg inn",
        register: "Registrer deg",
        forgotPassword: "Glemt passord?",
        resetPassword: "Tilbakestill passord",
        welcomeBack: "Velkommen tilbake",
        loginSubtitle: "Logg inn for å fortsette reisen din",
        emailOrUsername: "E-post eller brukernavn",
        emailAddress: "E-postadresse",
        password: "Passord",
        newPassword: "Nytt passord",
        confirmPassword: "Bekreft passord",
        signUpQuestion: "Har du ikke konto?",
        signUp: "Registrer deg",
        backToHome: "Tilbake til startsiden",
        backToLogin: "Tilbake til innlogging",
        createAccount: "Opprett konto",
        createAccountSubtitle: "Bli med i det globale radiofellesskapet",
        fullName: "Fullt navn",
        username: "Brukernavn",
        alreadyHaveAccount: "Har du allerede en konto?",
        sendResetLink: "Send tilbakestillingslenke",
        setNewPassword: "Sett nytt passord",

        // Discover
        discoverTitle: "Oppdag radio",
        discoverSubtitle: "Utforsk radiostasjoner fra hele verden",
        searchPlaceholder: "Søk etter stasjoner, land, byer...",
        allGenres: "Alle sjangre",
        trendingNow: "Populært nå",
        newStations: "Nye stasjoner",
        allStations: "Alle stasjoner",
        noStationsFound: "Ingen stasjoner funnet.",
        plays: "avspillinger",

        // Notifications / Friends
        notificationsTitle: "Varsler",
        notificationsSubtitle: "Venneforespørsler og oppdateringer fra WORLDofRADIO.",
        friendRequests: "Venneforespørsler",
        noFriendRequests: "Ingen åpne venneforespørsler.",
        updates: "Oppdateringer",
        noNotifications: "Ingen varsler ennå.",
        unreadNotification: "ulest varsel",
        unreadNotifications: "uleste varsler",
        markAllAsRead: "Merk alle som lest",
        loadingNotifications: "Laster varsler...",
        accept: "Godta",
        reject: "Avvis",
        unknownUser: "Ukjent bruker",
        wantsToBeFriend: "vil bli venn med deg",
        refresh: "Oppdater",

        // User search / friendship
        users: "Brukere",
        userSearch: "Søk etter brukere",
        userSearchPlaceholder: "Søk etter brukernavn, navn, land eller musikksjanger...",
        noUsersFound: "Ingen brukere funnet.",
        addFriend: "Legg til venn",
        requestSent: "Forespørsel sendt",
        friends: "Venner",
        incomingRequest: "Forespørsel mottatt",
        viewProfile: "Vis profil",

        // Legal common
        legalBack: "Tilbake",
        legalContact: "Kontakt",
        legalWebsite: "Nettsted",
        legalAddress: "Adresse",
        legalEmail: "E-post",
        legalOperator: "Operatør",
        legalOpen: "Åpne",
        legalSectionTitle: "Juridisk",

        // Footer / Settings legal labels
        imprintLink: "Juridisk informasjon",
        privacyLink: "Personvern",
        imprintCardText: "Operatørinformasjon og juridisk merknad.",
        privacyCardText: "Informasjon om behandling av personopplysninger.",

        // Imprint page
        imprintBadge: "Juridisk informasjon",
        imprintTitle: "Juridisk informasjon",
        imprintSubtitle: "Informasjon i henhold til lovpålagte opplysningskrav for WORLD OF RADIO.",
        imprintOperatorTitle: "Operatør",
        imprintOperatorLabel: "Operatør av dette nettstedet",
        imprintProjectTitle: "Prosjekt og varemerkeinformasjon",
        imprintProjectLabel: "Prosjekt",
        imprintProjectName: "WORLD OF RADIO by VMS Recording",
        imprintBrandLabel: "Varemerkeinformasjon",
        imprintBrandText: "VMS «Vinyl macht sexy» er et ord-/bildemerke registrert hos det tyske patent- og varemerkekontoret av Martin Wolf.",
        imprintRegisterNumber: "Registreringsnummer",
        imprintExternalTitle: "Merknad om eksternt innhold",
        imprintExternalText: "WORLD OF RADIO viser radiostasjoner, stasjonsinformasjon, strømmedata og eventuelt stasjonslogoer. Innhold, strømmer, logoer og metadata kan komme fra eksterne kilder eller de respektive radiostasjonene.",

        // Privacy page
        privacyBadge: "Personvern",
        privacyTitle: "Personvernerklæring",
        privacyIntro: "Denne personvernerklæringen informerer om hvilke personopplysninger som behandles ved bruk av WORLD OF RADIO og til hvilke formål.",
        privacyControllerTitle: "Behandlingsansvarlig",
        privacyProcessedDataTitle: "Hvilke data behandles",
        privacyProcessedDataIntro: "Ved bruk av WORLD OF RADIO kan særlig følgende data behandles:",
        privacyDataEmail: "E-postadresse",
        privacyDataUsername: "Brukernavn",
        privacyDataPasswordHash: "Passord-hash",
        privacyDataProfile: "Profilopplysninger som land, musikksjangre og bio",
        privacyDataAvatar: "Profilbilde eller avatar, dersom brukt",
        privacyDataLanguage: "Språkinnstilling",
        privacyDataFavorites: "Favoritter",
        privacyDataComments: "Kommentarer og kommentarlikes",
        privacyDataFriends: "Venneforespørsler og vennskap",
        privacyDataNotifications: "Varsler innenfor plattformen",
        privacyDataSession: "Tekniske innloggings- og øktdata",
        privacyDataAccess: "Tekniske tilgangsdata som IP-adresse, tidsstempel, nettleser- og enhetsinformasjon",
        privacyPurposeTitle: "Formål med behandlingen",
        privacyPurposeText: "Behandlingen skjer for å levere WORLD OF RADIO, administrere brukerkontoer, muliggjøre innlogging og registrering, vise radiostasjoner, teknisk gjennomføre favoritter, kommentarer, vennskap og varsler samt sikre plattformens sikkerhet og stabilitet.",
        privacyHostingTitle: "Hosting og teknisk infrastruktur",
        privacyHostingText1: "WORLD OF RADIO leveres via Vercel. Når nettstedet åpnes, kan tekniske tilgangsdata behandles som er nødvendige for levering, sikkerhet, stabilitet og drift av nettstedet.",
        privacyHostingText2: "Frontend er basert på React. Backend er implementert som en Python-/FastAPI-applikasjon. Datalagring skjer via MongoDB Atlas.",
        privacyAnalyticsTitle: "Vercel Analytics",
        privacyAnalyticsText: "WORLD OF RADIO bruker Vercel Analytics for teknisk analyse av bruken av nettstedet. Informasjon som sidevisninger, opprinnelsesland og bruksstatistikk kan behandles. Analysen bidrar til å forbedre plattformen, oppdage tekniske problemer og forstå bruken bedre.",
        privacyMailTitle: "E-postutsendelse",
        privacyMailText: "Serverbasert SMTP-e-postutsendelse brukes for registrering, e-postverifisering og funksjoner for tilbakestilling av passord. Tilgangsdata for e-postutsendelse lagres ikke i frontend, men administreres serverbasert via miljøvariabler.",
        privacyFontsTitle: "Google Fonts",
        privacyFontsText: "WORLD OF RADIO integrerer skrifttyper via Google Fonts. Når disse skrifttypene lastes, kan det opprettes en forbindelse til Googles servere. Tekniske data som IP-adresse, nettleserinformasjon og forespurte ressurser kan overføres.",
        privacyRadioTitle: "Radio Browser API og eksterne stasjonsdata",
        privacyRadioText1: "WORLD OF RADIO bruker eksterne radiostasjonsdata, særlig via Radio Browser API eller sammenlignbare kilder. Dette kan vise stasjonsnavn, land, sjangre, stream-URL-er, stasjonsmetadata og eventuelt stasjonslogoer.",
        privacyRadioText2: "Ved avspilling eller åpning av radiostasjoner kan det også opprettes forbindelser til eksterne stream-servere hos de respektive radiostasjonene. De respektive tilbyderne er ansvarlige for dette eksterne innholdet og streamene.",
        privacyStorageTitle: "Cookies, tokens og lokal lagring",
        privacyStorageText: "WORLD OF RADIO kan bruke tekniske cookies, tokens eller lokale lagringsmekanismer for å muliggjøre innlogging, øktadministrasjon, språkinnstillinger og grunnleggende plattformfunksjoner. Disse tekniske lagringene tjener funksjonalitet og sikkerhet.",
        privacyRetentionTitle: "Lagringstid",
        privacyRetentionText: "Personopplysninger lagres som hovedregel bare så lenge det er nødvendig for å levere plattformen, oppfylle lovpålagte plikter, ivareta sikkerhetsformål eller berettigede interesser. Brukerkontoer og tilknyttede data kan slettes på forespørsel, så langt ingen lovmessige eller tekniske grunner står i veien.",
        privacyRightsTitle: "Brukernes rettigheter",
        privacyRightsText1: "Brukere har innenfor lovens rammer blant annet rett til innsyn, retting, sletting, begrensning av behandling, dataportabilitet og innsigelse mot bestemte behandlinger.",
        privacyRightsText2: "Forespørsler om personvern kan sendes til:",
        privacyUpdated: "Sist oppdatert: juni 2026. Fremtidige utvidelser av plattformen kan gjøre det nødvendig å oppdatere denne personvernerklæringen.",
    },

    ko: {
        // Navbar
        navDiscover: "탐색",
        navSearch: "검색",
        navFavorites: "즐겨찾기",
        navLanguage: "언어",
        navProfile: "프로필",
        navMyProfile: "내 프로필",
        navSettings: "설정",
        navAdmin: "관리자 대시보드",
        navLogout: "로그아웃",
        navLogin: "로그인",
        navSignup: "가입하기",

        // Language overlay
        chooseLanguage: "언어 선택",
        displayLanguageFor: "WORLDofRADIO 표시 언어",
        tapToSelect: "선택하려면 누르세요",

        // Auth
        login: "로그인",
        register: "가입하기",
        forgotPassword: "비밀번호를 잊으셨나요?",
        resetPassword: "비밀번호 재설정",
        welcomeBack: "다시 오신 것을 환영합니다",
        loginSubtitle: "계속하려면 로그인하세요",
        emailOrUsername: "이메일 또는 사용자 이름",
        emailAddress: "이메일 주소",
        password: "비밀번호",
        newPassword: "새 비밀번호",
        confirmPassword: "비밀번호 확인",
        signUpQuestion: "계정이 없으신가요?",
        signUp: "가입하기",
        backToHome: "홈으로 돌아가기",
        backToLogin: "로그인으로 돌아가기",
        createAccount: "계정 만들기",
        createAccountSubtitle: "글로벌 라디오 커뮤니티에 참여하세요",
        fullName: "전체 이름",
        username: "사용자 이름",
        alreadyHaveAccount: "이미 계정이 있으신가요?",
        sendResetLink: "재설정 링크 보내기",
        setNewPassword: "새 비밀번호 설정",

        // Discover
        discoverTitle: "라디오 탐색",
        discoverSubtitle: "전 세계의 라디오 방송국을 탐색하세요",
        searchPlaceholder: "방송국, 국가, 도시 검색...",
        allGenres: "전체 장르",
        trendingNow: "인기 방송",
        newStations: "새 방송국",
        allStations: "전체 방송국",
        noStationsFound: "검색 결과가 없습니다.",
        plays: "재생",

        // Notifications / Friends
        notificationsTitle: "알림",
        notificationsSubtitle: "WORLDofRADIO의 친구 요청 및 업데이트입니다.",
        friendRequests: "친구 요청",
        noFriendRequests: "열린 친구 요청이 없습니다.",
        updates: "업데이트",
        noNotifications: "아직 알림이 없습니다.",
        unreadNotification: "읽지 않은 알림",
        unreadNotifications: "읽지 않은 알림",
        markAllAsRead: "모두 읽음으로 표시",
        loadingNotifications: "알림을 불러오는 중...",
        accept: "수락",
        reject: "거절",
        unknownUser: "알 수 없는 사용자",
        wantsToBeFriend: "님이 친구 요청을 보냈습니다",
        refresh: "새로고침",

        // User search / friendship
        users: "사용자",
        userSearch: "사용자 검색",
        userSearchPlaceholder: "사용자 이름, 이름, 국가 또는 음악 장르 검색...",
        noUsersFound: "사용자를 찾을 수 없습니다.",
        addFriend: "친구 추가",
        requestSent: "요청 전송됨",
        friends: "친구",
        incomingRequest: "요청 받음",
        viewProfile: "프로필 보기",

        // Legal common
        legalBack: "뒤로",
        legalContact: "연락처",
        legalWebsite: "웹사이트",
        legalAddress: "주소",
        legalEmail: "이메일",
        legalOperator: "운영자",
        legalOpen: "열기",
        legalSectionTitle: "법적 정보",

        // Footer / Settings legal labels
        imprintLink: "법적 고지",
        privacyLink: "개인정보 처리방침",
        imprintCardText: "운영자 정보 및 법적 고지입니다.",
        privacyCardText: "개인정보 처리에 관한 정보입니다.",

        // Imprint page
        imprintBadge: "법적 고지",
        imprintTitle: "법적 고지",
        imprintSubtitle: "WORLD OF RADIO에 대한 법적 정보 제공 의무에 따른 안내입니다.",
        imprintOperatorTitle: "운영자",
        imprintOperatorLabel: "이 웹사이트의 운영자",
        imprintProjectTitle: "프로젝트 및 상표 고지",
        imprintProjectLabel: "프로젝트",
        imprintProjectName: "WORLD OF RADIO by VMS Recording",
        imprintBrandLabel: "상표 고지",
        imprintBrandText: "VMS “Vinyl macht sexy”는 Martin Wolf가 독일 특허상표청에 등록한 문자/도형 상표입니다.",
        imprintRegisterNumber: "등록번호",
        imprintExternalTitle: "외부 콘텐츠에 대한 안내",
        imprintExternalText: "WORLD OF RADIO는 라디오 방송국, 방송국 정보, 스트림 데이터 및 제공되는 경우 방송국 로고를 표시합니다. 콘텐츠, 스트림, 로고 및 메타데이터는 외부 출처 또는 해당 라디오 방송국에서 제공될 수 있습니다.",

        // Privacy page
        privacyBadge: "개인정보",
        privacyTitle: "개인정보 처리방침",
        privacyIntro: "이 개인정보 처리방침은 WORLD OF RADIO 이용 시 어떤 개인정보가 어떤 목적으로 처리되는지 안내합니다.",
        privacyControllerTitle: "개인정보 처리 책임자",
        privacyProcessedDataTitle: "처리되는 데이터",
        privacyProcessedDataIntro: "WORLD OF RADIO 이용 시 특히 다음 데이터가 처리될 수 있습니다:",
        privacyDataEmail: "이메일 주소",
        privacyDataUsername: "사용자 이름",
        privacyDataPasswordHash: "비밀번호 해시",
        privacyDataProfile: "국가, 음악 장르, 자기소개 등 프로필 정보",
        privacyDataAvatar: "사용하는 경우 프로필 사진 또는 아바타",
        privacyDataLanguage: "언어 설정",
        privacyDataFavorites: "즐겨찾기",
        privacyDataComments: "댓글 및 댓글 좋아요",
        privacyDataFriends: "친구 요청 및 친구 관계",
        privacyDataNotifications: "플랫폼 내 알림",
        privacyDataSession: "기술적 로그인 및 세션 데이터",
        privacyDataAccess: "IP 주소, 시간 정보, 브라우저 및 기기 정보와 같은 기술적 접근 데이터",
        privacyPurposeTitle: "처리 목적",
        privacyPurposeText: "데이터 처리는 WORLD OF RADIO 제공, 사용자 계정 관리, 로그인 및 등록 지원, 라디오 방송국 표시, 즐겨찾기, 댓글, 친구 관계 및 알림 기능 구현, 플랫폼의 보안과 안정성 확보를 위해 이루어집니다.",
        privacyHostingTitle: "호스팅 및 기술 인프라",
        privacyHostingText1: "WORLD OF RADIO는 Vercel을 통해 제공됩니다. 웹사이트 접속 시 웹사이트 제공, 보안, 안정성 및 운영에 필요한 기술적 접근 데이터가 처리될 수 있습니다.",
        privacyHostingText2: "프론트엔드는 React 기반이며, 백엔드는 Python/FastAPI 애플리케이션으로 구현되어 있습니다. 데이터 저장은 MongoDB Atlas를 통해 이루어집니다.",
        privacyAnalyticsTitle: "Vercel Analytics",
        privacyAnalyticsText: "WORLD OF RADIO는 웹사이트 이용을 기술적으로 분석하기 위해 Vercel Analytics를 사용합니다. 페이지 조회, 접속 국가 및 이용 통계와 같은 정보가 처리될 수 있습니다. 이 분석은 플랫폼 개선, 기술적 문제 파악 및 이용 현황 이해를 위해 사용됩니다.",
        privacyMailTitle: "이메일 발송",
        privacyMailText: "등록, 이메일 인증 및 비밀번호 재설정 기능을 위해 서버 측 SMTP 이메일 발송이 사용됩니다. 이메일 발송 접근 정보는 프론트엔드에 저장되지 않고 서버 측 환경 변수로 관리됩니다.",
        privacyFontsTitle: "Google Fonts",
        privacyFontsText: "WORLD OF RADIO는 Google Fonts를 통해 글꼴을 불러옵니다. 글꼴 로딩 시 Google 서버와 연결될 수 있으며, IP 주소, 브라우저 정보 및 요청된 리소스와 같은 기술 데이터가 전송될 수 있습니다.",
        privacyRadioTitle: "Radio Browser API 및 외부 방송국 데이터",
        privacyRadioText1: "WORLD OF RADIO는 특히 Radio Browser API 또는 유사한 출처를 통해 외부 라디오 방송국 데이터를 사용합니다. 이를 통해 방송국 이름, 국가, 장르, 스트림 URL, 방송국 메타데이터 및 제공되는 경우 방송국 로고가 표시될 수 있습니다.",
        privacyRadioText2: "라디오 방송국을 재생하거나 열 때 해당 방송국의 외부 스트림 서버와 연결될 수 있습니다. 이러한 외부 콘텐츠와 스트림에 대한 책임은 해당 제공자에게 있습니다.",
        privacyStorageTitle: "쿠키, 토큰 및 로컬 저장소",
        privacyStorageText: "WORLD OF RADIO는 로그인, 세션 관리, 언어 설정 및 기본 플랫폼 기능을 제공하기 위해 기술적 쿠키, 토큰 또는 로컬 저장 방식을 사용할 수 있습니다. 이러한 기술적 저장은 기능성과 보안을 위한 것입니다.",
        privacyRetentionTitle: "보관 기간",
        privacyRetentionText: "개인정보는 원칙적으로 플랫폼 제공, 법적 의무, 보안 목적 또는 정당한 이익을 위해 필요한 기간 동안만 저장됩니다. 사용자 계정 및 관련 데이터는 법적 또는 기술적 사유가 없는 한 요청 시 삭제될 수 있습니다.",
        privacyRightsTitle: "이용자의 권리",
        privacyRightsText1: "이용자는 관련 법률에 따라 정보 열람, 정정, 삭제, 처리 제한, 데이터 이동성 및 특정 처리에 대한 반대 권리를 가질 수 있습니다.",
        privacyRightsText2: "개인정보 관련 문의는 다음 주소로 보낼 수 있습니다:",
        privacyUpdated: "최종 업데이트: 2026년 6월. 향후 플랫폼 기능이 확장될 경우 이 개인정보 처리방침이 수정될 수 있습니다.",
    },

    fi: {
        // Navbar
        navDiscover: "Löydä",
        navSearch: "Haku",
        navFavorites: "Suosikit",
        navLanguage: "Kieli",
        navProfile: "Profiili",
        navMyProfile: "Oma profiili",
        navSettings: "Asetukset",
        navAdmin: "Ylläpito",
        navLogout: "Kirjaudu ulos",
        navLogin: "Kirjaudu sisään",
        navSignup: "Rekisteröidy",

        // Language overlay
        chooseLanguage: "Valitse kieli",
        displayLanguageFor: "WORLDofRADIO:n näyttökieli",
        tapToSelect: "Valitse napauttamalla",

        // Auth
        login: "Kirjaudu sisään",
        register: "Rekisteröidy",
        forgotPassword: "Unohditko salasanan?",
        resetPassword: "Palauta salasana",
        welcomeBack: "Tervetuloa takaisin",
        loginSubtitle: "Kirjaudu sisään jatkaaksesi",
        emailOrUsername: "Sähköposti tai käyttäjänimi",
        emailAddress: "Sähköpostiosoite",
        password: "Salasana",
        newPassword: "Uusi salasana",
        confirmPassword: "Vahvista salasana",
        signUpQuestion: "Eikö sinulla ole tiliä?",
        signUp: "Rekisteröidy",
        backToHome: "Takaisin etusivulle",
        backToLogin: "Takaisin kirjautumiseen",
        createAccount: "Luo tili",
        createAccountSubtitle: "Liity maailmanlaajuiseen radioyhteisöön",
        fullName: "Koko nimi",
        username: "Käyttäjänimi",
        alreadyHaveAccount: "Onko sinulla jo tili?",
        sendResetLink: "Lähetä palautuslinkki",
        setNewPassword: "Aseta uusi salasana",

        // Discover
        discoverTitle: "Löydä radio",
        discoverSubtitle: "Tutustu radioasemiin ympäri maailmaa",
        searchPlaceholder: "Etsi asemia, maita, kaupunkeja...",
        allGenres: "Kaikki genret",
        trendingNow: "Nousussa nyt",
        newStations: "Uudet asemat",
        allStations: "Kaikki asemat",
        noStationsFound: "Asemia ei löytynyt.",
        plays: "toistoa",

        // Notifications / Friends
        notificationsTitle: "Ilmoitukset",
        notificationsSubtitle: "Ystäväpyynnöt ja päivitykset WORLDofRADIOsta.",
        friendRequests: "Ystäväpyynnöt",
        noFriendRequests: "Ei avoimia ystäväpyyntöjä.",
        updates: "Päivitykset",
        noNotifications: "Ei ilmoituksia vielä.",
        unreadNotification: "lukematon ilmoitus",
        unreadNotifications: "lukematonta ilmoitusta",
        markAllAsRead: "Merkitse kaikki luetuiksi",
        loadingNotifications: "Ladataan ilmoituksia...",
        accept: "Hyväksy",
        reject: "Hylkää",
        unknownUser: "Tuntematon käyttäjä",
        wantsToBeFriend: "haluaa olla ystäväsi",
        refresh: "Päivitä",

        // User search / friendship
        users: "Käyttäjät",
        userSearch: "Etsi käyttäjiä",
        userSearchPlaceholder: "Etsi käyttäjänimeä, nimeä, maata tai musiikkityyliä...",
        noUsersFound: "Käyttäjiä ei löytynyt.",
        addFriend: "Lisää ystävä",
        requestSent: "Pyyntö lähetetty",
        friends: "Ystävät",
        incomingRequest: "Pyyntö vastaanotettu",
        viewProfile: "Näytä profiili",

        // Legal common
        legalBack: "Takaisin",
        legalContact: "Yhteystiedot",
        legalWebsite: "Verkkosivusto",
        legalAddress: "Osoite",
        legalEmail: "Sähköposti",
        legalOperator: "Ylläpitäjä",
        legalOpen: "Avaa",
        legalSectionTitle: "Lakiasiat",

        // Footer / Settings legal labels
        imprintLink: "Lakisääteiset tiedot",
        privacyLink: "Tietosuoja",
        imprintCardText: "Ylläpitäjän tiedot ja lakisääteiset tiedot.",
        privacyCardText: "Tietoa henkilötietojen käsittelystä.",

        // Imprint page
        imprintBadge: "Lakisääteiset tiedot",
        imprintTitle: "Lakisääteiset tiedot",
        imprintSubtitle: "WORLD OF RADIO -palvelua koskevat lakisääteiset tiedot.",
        imprintOperatorTitle: "Ylläpitäjä",
        imprintOperatorLabel: "Tämän verkkosivuston ylläpitäjä",
        imprintProjectTitle: "Projekti ja tavaramerkkitiedot",
        imprintProjectLabel: "Projekti",
        imprintProjectName: "WORLD OF RADIO by VMS Recording",
        imprintBrandLabel: "Tavaramerkkitiedot",
        imprintBrandText: "VMS “Vinyl macht sexy” on Martin Wolfin Saksan patentti- ja tavaramerkkivirastossa rekisteröimä sana-/kuvamerkki.",
        imprintRegisterNumber: "Rekisterinumero",
        imprintExternalTitle: "Huomautus ulkoisesta sisällöstä",
        imprintExternalText: "WORLD OF RADIO näyttää radioasemia, asematietoja, suoratoistotietoja ja mahdollisia asemalogoja. Sisältö, streamit, logot ja metatiedot voivat olla peräisin ulkoisista lähteistä tai kyseisiltä radioasemilta.",

        // Privacy page
        privacyBadge: "Tietosuoja",
        privacyTitle: "Tietosuojaseloste",
        privacyIntro: "Tämä tietosuojaseloste kertoo, mitä henkilötietoja käsitellään WORLD OF RADIO -palvelun käytön yhteydessä ja mihin tarkoituksiin.",
        privacyControllerTitle: "Rekisterinpitäjä",
        privacyProcessedDataTitle: "Mitä tietoja käsitellään",
        privacyProcessedDataIntro: "WORLD OF RADIO -palvelun käytön yhteydessä voidaan käsitellä erityisesti seuraavia tietoja:",
        privacyDataEmail: "Sähköpostiosoite",
        privacyDataUsername: "Käyttäjänimi",
        privacyDataPasswordHash: "Salasanan tiiviste",
        privacyDataProfile: "Profiilitiedot, kuten maa, musiikkityylit ja bio",
        privacyDataAvatar: "Profiilikuva tai avatar, jos käytössä",
        privacyDataLanguage: "Kieliasetus",
        privacyDataFavorites: "Suosikit",
        privacyDataComments: "Kommentit ja kommenttien tykkäykset",
        privacyDataFriends: "Ystäväpyynnöt ja ystävyyssuhteet",
        privacyDataNotifications: "Alustan sisäiset ilmoitukset",
        privacyDataSession: "Tekniset kirjautumis- ja istuntotiedot",
        privacyDataAccess: "Tekniset käyttötiedot, kuten IP-osoite, aikaleima, selaimen ja laitteen tiedot",
        privacyPurposeTitle: "Käsittelyn tarkoitukset",
        privacyPurposeText: "Tietoja käsitellään WORLD OF RADIO -palvelun tarjoamiseksi, käyttäjätilien hallitsemiseksi, kirjautumisen ja rekisteröinnin mahdollistamiseksi, radioasemien näyttämiseksi, suosikkien, kommenttien, ystävyyksien ja ilmoitusten tekniseksi toteuttamiseksi sekä alustan turvallisuuden ja vakauden varmistamiseksi.",
        privacyHostingTitle: "Hosting ja tekninen infrastruktuuri",
        privacyHostingText1: "WORLD OF RADIO tarjotaan Vercelin kautta. Sivustoa avattaessa voidaan käsitellä teknisiä käyttötietoja, jotka ovat tarpeen sivuston toimittamiseksi, turvallisuuden, vakauden ja toiminnan varmistamiseksi.",
        privacyHostingText2: "Frontend perustuu Reactiin. Backend on toteutettu Python-/FastAPI-sovelluksena. Tietojen tallennus tapahtuu MongoDB Atlas -palvelun kautta.",
        privacyAnalyticsTitle: "Vercel Analytics",
        privacyAnalyticsText: "WORLD OF RADIO käyttää Vercel Analyticsia sivuston käytön tekniseen analysointiin. Tietoja, kuten sivunäyttöjä, lähtömaita ja käyttötilastoja, voidaan käsitellä. Analyysi auttaa parantamaan alustaa, havaitsemaan teknisiä ongelmia ja ymmärtämään käyttöä paremmin.",
        privacyMailTitle: "Sähköpostin lähetys",
        privacyMailText: "Rekisteröintiä, sähköpostivahvistusta ja salasanan palautustoimintoja varten käytetään palvelinpuolen SMTP-sähköpostilähetystä. Sähköpostilähetyksen käyttöoikeustietoja ei tallenneta frontendissä, vaan niitä hallitaan palvelinpuolen ympäristömuuttujilla.",
        privacyFontsTitle: "Google Fonts",
        privacyFontsText: "WORLD OF RADIO käyttää Google Fonts -kirjasimia. Kirjasimia ladattaessa voidaan muodostaa yhteys Googlen palvelimiin. Tällöin voidaan välittää teknisiä tietoja, kuten IP-osoite, selaintiedot ja pyydetyt resurssit.",
        privacyRadioTitle: "Radio Browser API ja ulkoiset asematiedot",
        privacyRadioText1: "WORLD OF RADIO käyttää ulkoisia radioasematietoja, erityisesti Radio Browser API:n tai vastaavien lähteiden kautta. Näin voidaan näyttää asemien nimiä, maita, genrejä, stream-URL-osoitteita, asemametadataa ja mahdollisia asemalogoja.",
        privacyRadioText2: "Radioasemaa toistettaessa tai avattaessa voidaan muodostaa yhteyksiä kyseisten radioasemien ulkoisiin stream-palvelimiin. Kyseiset tarjoajat vastaavat näistä ulkoisista sisällöistä ja streameista.",
        privacyStorageTitle: "Evästeet, tokenit ja paikallinen tallennus",
        privacyStorageText: "WORLD OF RADIO voi käyttää teknisiä evästeitä, tokeneita tai paikallisia tallennusmekanismeja kirjautumisen, istunnonhallinnan, kieliasetusten ja perustoimintojen mahdollistamiseksi. Nämä tekniset tallennukset palvelevat toiminnallisuutta ja turvallisuutta.",
        privacyRetentionTitle: "Säilytysaika",
        privacyRetentionText: "Henkilötietoja säilytetään lähtökohtaisesti vain niin kauan kuin se on tarpeen alustan tarjoamiseksi, lakisääteisten velvoitteiden, turvallisuustarkoitusten tai oikeutettujen etujen vuoksi. Käyttäjätilit ja niihin liittyvät tiedot voidaan poistaa pyynnöstä, mikäli oikeudelliset tai tekniset syyt eivät estä poistamista.",
        privacyRightsTitle: "Käyttäjien oikeudet",
        privacyRightsText1: "Käyttäjillä on sovellettavan lainsäädännön mukaisesti muun muassa oikeus saada pääsy tietoihin, oikaista, poistaa, rajoittaa käsittelyä, siirtää tiedot järjestelmästä toiseen sekä vastustaa tiettyä käsittelyä.",
        privacyRightsText2: "Tietosuojaan liittyvät pyynnöt voi lähettää osoitteeseen:",
        privacyUpdated: "Päivitetty: kesäkuu 2026. Alustan tulevat laajennukset voivat edellyttää tämän tietosuojaselosteen päivittämistä.",
    },
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguageState] = useState("en");

    useEffect(() => {
        const savedLanguage = localStorage.getItem(STORAGE_KEY);

        if (savedLanguage && translations[savedLanguage]) {
            setLanguageState(savedLanguage);
            return;
        }

        const browserLanguage = navigator.language?.slice(0, 2).toLowerCase();

        if (browserLanguage === "de") {
            setLanguageState("de");
        } else if (
            browserLanguage === "no" ||
            browserLanguage === "nb" ||
            browserLanguage === "nn"
        ) {
            setLanguageState("no");
        } else if (browserLanguage === "ko") {
            setLanguageState("ko");
        } else if (browserLanguage === "fi") {
            setLanguageState("fi");
        } else {
            setLanguageState("en");
        }
    }, []);

    const setLanguage = (newLanguage) => {
        if (!translations[newLanguage]) return;

        localStorage.setItem(STORAGE_KEY, newLanguage);
        setLanguageState(newLanguage);
    };

    const value = useMemo(() => {
        return {
            language,
            setLanguage,
            languages,
            t: translations[language] || translations.en,
        };
    }, [language]);

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);

    if (!context) {
        throw new Error("useLanguage must be used inside LanguageProvider");
    }

    return context;
};